<template>
  <div
    class="group h-18 min-w-46.5 w-fit flex gap-2 absolute p-2 bg-key rounded-m"
    @click.stop="
      deviceStore.handleDeviceClick(deviceItem, undefined, getCarouselClickCanRoute($event))
    "
  >
    <div class="rounded-m">
      <img class="w-23 h-14 object-cover" :src="getImageUrl(deviceItem.img)" draggable="false" />
    </div>
    <div class="flex flex-col justify-center gap-1">
      <div
        class="wrap-break-word text-m-medium text-black-white transition-colors group-hover:text-blue-dark-hover"
      >
        {{ deviceItem.name }}
      </div>
      <Icon
        icon="Function-FiII-CurrentClick"
        class="size-4 transition-colors text-black-white group-hover:text-blue-dark-hover"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { useDeviceStore } from '@/stores'
  import { getImageUrl } from '@/utils/assets'
  import { BaseDevice } from '@rapoo/device-sdk'
  import { Icon } from '@rapoo/element'
  import { computed } from 'vue'

  type CarouselCardClickEvent = MouseEvent & {
    __carouselWasActive?: boolean
  }

  const props = defineProps<{
    item: BaseDevice
  }>()

  const deviceStore = useDeviceStore()
  const deviceItem = computed(() => deviceStore.baseDeviceToDeviceItem(props.item))

  const getCarouselClickCanRoute = (e: MouseEvent) => {
    return (e as CarouselCardClickEvent).__carouselWasActive ?? true
  }
</script>
